import React from 'react';
import { commonOverlayStyle } from './overlayStyles';
import { WifiOff, RefreshCw } from 'lucide-react';

const ConnectionStatusOverlay = ({ reconnectionStatus, reconnectAttempts, maxReconnectAttempts, onRetry }) => {
  // Only show the overlay when we're in a problematic connection state
  if (reconnectionStatus === 'connected') {
    return null;
  }
  
  // Determine if this is the initial loading state
  const isInitialLoading = reconnectionStatus === 'loading';

  return (
    <div style={{
      ...commonOverlayStyle,
      backgroundColor: 'rgba(0, 0, 0, 0.85)', // Darker background for better visibility
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '500px',
        padding: '30px',
        backgroundColor: 'rgba(30, 41, 59, 0.9)', // Dark blue background
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
      }}>
        {isInitialLoading ? (
          <RefreshCw 
            size={48} 
            color="#60a5fa" 
            style={{ 
              animation: 'spin 1.5s linear infinite',
              marginBottom: '20px'
            }} 
          />
        ) : (
          <WifiOff size={48} color="#f87171" style={{ marginBottom: '20px' }} />
        )}
        
        <h1 style={{
          color: '#f1f5f9',
          fontSize: '24px',
          marginBottom: '15px',
          fontWeight: '600',
          textAlign: 'center'
        }}>
          {reconnectionStatus === 'max_attempts_reached' 
            ? 'Connection Lost' 
            : isInitialLoading 
              ? 'Establishing Connection...' 
              : 'Reconnecting...'}
        </h1>
        
        <p style={{
          color: '#cbd5e1',
          fontSize: '16px',
          marginBottom: '25px',
          textAlign: 'center',
          lineHeight: '1.5'
        }}>
          {reconnectionStatus === 'max_attempts_reached' 
            ? `We've tried to reconnect ${maxReconnectAttempts} times without success. Please check your internet connection and try again.` 
            : isInitialLoading
              ? 'Connecting to the interview server. Please wait...'
              : `Attempting to reconnect (${reconnectAttempts}/${maxReconnectAttempts})... Please wait.`}
        </p>
        
        {reconnectionStatus === 'max_attempts_reached' && (
          <button
            onClick={onRetry}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              backgroundColor: '#3b82f6',
              padding: '12px 24px',
              borderRadius: '6px',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '500',
              border: 'none',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2563eb';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#3b82f6';
            }}
          >
            <RefreshCw size={20} />
            Retry Connection
          </button>
        )}
        
        {(reconnectionStatus === 'connecting' || reconnectionStatus === 'loading') && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            marginTop: '10px'
          }}>
            <RefreshCw 
              size={20} 
              color="#60a5fa" 
              style={{ 
                animation: 'spin 1.5s linear infinite'
              }} 
            />
            <style jsx>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
            <span style={{ color: '#60a5fa' }}>
              {isInitialLoading ? 'Establishing connection...' : 'Attempting to reconnect...'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConnectionStatusOverlay;
